module.exports = __webpack_public_path__ + "img/recruiment-active.91c46f5a.svg";